<template>
  <div class="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900">
    <div class="p-6">
      <h5 class="text-xl font-semibold">{{ $t('job.detail.sidebar-title') }}</h5>
    </div>
    <div class="p-6 border-t border-slate-100 dark:border-t-gray-700">
      <ul class="list-none">
        <li class="flex items-start">
          <i class="uil uil-user-check text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.type') }}:</p>
            <span class="text-primary-color font-medium text-sm">{{ job?.type ? job?.type.name : 'Vollzeit' }}</span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-building text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.mode') }}:</p>
            <span class="text-primary-color font-medium text-sm"><span
                v-html="job?.mode ? job?.mode.name : 'Vor Ort'"></span></span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-folder-open text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.category') }}:</p>
            <span class="text-primary-color font-medium text-sm"><span
                v-html="job?.category ? job?.category.name : ''"></span></span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-briefcase text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.experience') }}:</p>
            <span class="text-primary-color font-medium text-sm">{{ job?.experience ? job?.experience.name : '2+ years'}}</span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-pen text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.status') }}:</p>
            <span class="text-primary-color font-medium text-sm">{{ job?.contract?.name ? job.contract.name : 'Angestellt' }}</span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-clock text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.date') }}:</p>
            <span class="text-primary-color font-medium text-sm">{{ job?.createdAt }}</span>
          </div>
        </li>

        <li class="flex items-start mt-3">
          <i class="uil uil-location-point text-[20px]"></i>

          <div class="ms-4">
            <p class="font-medium">{{ $t('job.detail.location') }}:</p>
            <span class="text-primary-color font-medium text-sm">{{ job?.location?.name ? job.location.name : '' }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    job: { type: Object, required: true },
  },
  mounted() {
    this.id = this.$route.params.id;
  },
}
</script>

<style lang="scss" scoped></style>
